"use client";
import React from "react";
import PropTypes from "prop-types";
import {
  ButtonItem,
  Title,
  InText,
  ItemData,
  Segmant,
  Wcomment,
} from "../../components";
import { Grid, Divider, Icon, Label } from "semantic-ui-react";
// import Link from "next/link";
import dynamic from "next/dynamic";

const Link = dynamic(() => import("react-scroll").then((mod) => mod.Carousel), {
  ssr: false,
});

const Description = ({
  desData,
  display,
  show,
  toggle,
  visibility,
  change,
  like,
  onLike,
  review,
}) => {
  let limit = 200;
  return (
    <div>
      {desData.map((grid, index) => (
        <div key={index}>
          <Segmant>
            <Title name={grid.heading} size="medium" />
            {grid.p1.length <= limit ? (
              <InText name={grid.p1} floated="left" />
            ) : display[index] ? (
              <div>
                <InText name={grid.p1} floated="left" />
                <span
                  style={{
                    display: "inline-block",
                    cursor: "pointer",
                    width: "100%",
                  }}
                  onClick={(e) => show(index, e)}
                >
                  <Title
                    name="Show Less"
                    color="blue"
                    floated="right"
                    size="small"
                  />
                </span>
              </div>
            ) : (
              <div>
                <InText
                  name={grid.p1.substring(0, limit) + " ..."}
                  floated="left"
                />
                <span
                  style={{
                    display: "inline-block",
                    cursor: "pointer",
                    width: "100%",
                  }}
                  onClick={(e) => show(index, e)}
                >
                  <Title
                    name="Show More"
                    color="blue"
                    floated="right"
                    size="small"
                  />
                </span>
              </div>
            )}
          </Segmant>
          <Segmant textAlign="center">
            {like[index] ? (
              // <ButtonItem onClick={e=>onLike(index,e)} basic icon ><Icon name="thumbs up" color="#c02e26" />Helpful</ButtonItem>:
              <ButtonItem
                name="desc"
                onClick={(e) => onLike(index, e)}
                basic
                icon="thumbs up"
                content="Helpful"
              />
            ) : (
              <ButtonItem
                name="desc"
                onClick={(e) => onLike(index, e)}
                basic
                icon="thumbs up outline"
                content="Helpful"
              />
            )}
            <Link
              to="comment_box"
              activeClass="active"
              spy
              smooth
              offset={-70}
              duration={500}
              href="#"
            >
              <ButtonItem
                basic
                icon="comment outline"
                content="Comment"
                onClick={(e) => toggle(index, e)}
              />
            </Link>
          </Segmant>
          <Grid padded>
            <Grid.Column mobile={6} tablet={5} computer={4}>
              <Title name={grid.heading1} size="small" floated="left" />
            </Grid.Column>
            <Grid.Column mobile={8} tablet={6} computer={6}>
              <ItemData
                size="tiny"
                source={grid.image}
                head={grid.itemhead}
                subhead={grid.itemsub}
                desc={grid.desc}
                style={{ color: "blue", cursor: "pointer" }}
                href="/ProfileRealtor"
              />
            </Grid.Column>
          </Grid>
          <Segmant id="comment_box">
            <Wcomment
              name="oncomment"
              change={change}
              visibility={visibility[index]}
            />
          </Segmant>
        </div>
      ))}
      <Segmant>
        {/* <ButtonItem
          size="small"
          color="#c02e26"
          icon
          labelPosition="right"
          floated="right"
          onClick={(e) => review(e)}
        >
          Write a Review <Icon name="write" />
        </ButtonItem> */}
        <ButtonItem
          as="div"
          labelPosition="right"
          floated="left"
          onClick={(e) => review(e)}
          className="theme_blue btn_blue"
        >
          <ButtonItem
            //color="#1b57a5"
            icon="write"
            className="btn_blue_bg"
          />
          <Label
            as="a"
            name="saveNeighbor"
            content="Write a Review"
            basic
            //color="#1b57a5"
            pointing="left"
            className="theme_blue btn_blue"
          />
        </ButtonItem>
      </Segmant>
      <Divider hidden />
      <Divider hidden />
      <Divider />
    </div>
  );
};

Description.propTypes = {
  desData: PropTypes.array.isRequired,
};

export default Description;
